import { calendar_v3 } from "googleapis";
import { useMemo } from "react";
import { formatEventDateRange } from "../../lib/format-event-date-range";
import "./EventCard.scss";

interface EventCardProps {
  event: calendar_v3.Schema$Event;
}

const EventCard = ({ event }: EventCardProps) => {
  const attendeeEmails = useMemo(() => {
    return (event.attendees ?? []).map((attendee) => attendee.email);
  }, [event]);

  const emails = new Set(
    [
      ...attendeeEmails,
      event.creator?.email ?? "",
      event.organizer?.email ?? "",
    ].filter(Boolean)
  );
  const attendees = Array.from(emails).join(", ");

  return (
    <div className="event-card">
      <div className="event-card-summary">{event.summary}</div>
      <div className="metadata">
        {formatEventDateRange(event)} &middot; Attendees: {attendees}
      </div>
    </div>
  );
};

export default EventCard;
